import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface HVACDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const HVACDescription: React.FC<HVACDescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [hvac, set_hvac] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['HVAC']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'HVAC': [v, b.values?.['Major Systems']?.['HVAC']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={hvac}
                />
            ) : (
                <TextBox
                    value={hvac}
                    onChange={(value) => set_hvac(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
